import React from 'react'
import styled from 'styled-components'
import { darken, lighten } from 'polished'

import { RowBetween } from '../Row'
import { ChevronDown } from 'react-feather'
import { Button as RebassButton, ButtonProps } from 'rebass/styled-components'

const Base = styled(RebassButton)<{
  padding?: string
  width?: string
  borderRadius?: string
  altDisabledStyle?: boolean
}>`
  padding: ${({ padding }) => (padding ? padding : '18px')};
  width: ${({ width }) => (width ? width : '100%')};
  font-weight: 500;
  text-align: center;
  border-radius: 8px;
  border-radius: ${({ borderRadius }) => borderRadius && borderRadius};
  outline: none;
  border: 1px solid transparent;
  color: white;
  text-decoration: none;
  display: flex;
  justify-content: center;
  flex-wrap: nowrap;
  align-items: center;
  cursor: pointer;
  position: relative;
  // z-index: 1;
  &:disabled {
    cursor: auto;
  }

  > * {
    user-select: none;
  }
`

export const ButtonPrimary = styled(Base)`
  // background-color: ${({ theme }) => theme.primary1};
  // background-image: linear-gradient(80deg, #1fc7ae 13%, #7c73b4 86%);

  border-radius: 5px;
  border-style: solid;
  border-width: 1px;

  // background-image: linear-gradient(281deg, #b58947 223%, #a3732f 195%, #361f00 179%, #ffeaa5 146%, #cea253 63%, #82561d 40%, #a07a3f 32%, #d3b879 16%, #f2de9d 6%, #ffedab 1%, #ead290 -10%, #b88e4b -28%, #a3732f -35%), linear-gradient(283deg, #b58947 82%, #a3732f 75%, #ffeaa5 62%, #cea253 41%, #82561d 36%, #a07a3f 34%, #d3b879 30%, #f2de9d 27%, #ffedab 26%, #ead290 23%, #b88e4b 19%, #a3732f 17%);
  
  color: white;

  &:focus {
    box-shadow: none;
  }
  &:hover {
    box-shadow: 0px 4px 30px 0px rgba(206, 162, 83, .4);
  }
  &:active {
    box-shadow: none;
    outline: none;
  }
  &:disabled {
    background-image: none;
    background-color: ${({ theme, altDisabledStyle, disabled }) => altDisabledStyle ? (disabled ? theme.bg3 : theme.primary1) : theme.bg3};
    color: ${({ theme, altDisabledStyle, disabled }) => altDisabledStyle ? (disabled ? theme.text3 : 'white') : theme.text3};
    cursor: auto;
    box-shadow: none;
    border: 1px solid transparent;
    border: none;
    outline: none;
    opacity: ${({ altDisabledStyle }) => (altDisabledStyle ? '0.5' : '1')};
  }

  background: linear-gradient(#11314a, #0c2539) padding-box, linear-gradient(273deg, #b58947, #a3732f, #ffeaa5, #cea253, #d3b879, #f2de9d, #ffedab, #ead290, #b88e4b, #a3732f) border-box;
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#a3732f",endColorstr="#b58947",GradientType=1);

  transition-property: all;
  transition-duration: .2s;
  transition-timing-function: cubic-bezier(.4,0,.2,1);
  animation-duration: .2s;
  animation-timing-function: cubic-bezier(.4,0,.2,1);
`

// export const ButtonPrimary = styled(Base)`
//   // background-color: ${({ theme }) => theme.primary1};
//   // background-image: linear-gradient(80deg, #1fc7ae 13%, #7c73b4 86%);

//   border-radius: 5px;
//   border-style: solid;
//   border-width: 1px;

//   background-image: linear-gradient(281deg, #b58947 223%, #a3732f 195%, #361f00 179%, #ffeaa5 146%, #cea253 63%, #82561d 40%, #a07a3f 32%, #d3b879 16%, #f2de9d 6%, #ffedab 1%, #ead290 -10%, #b88e4b -28%, #a3732f -35%), linear-gradient(283deg, #b58947 82%, #a3732f 75%, #ffeaa5 62%, #cea253 41%, #82561d 36%, #a07a3f 34%, #d3b879 30%, #f2de9d 27%, #ffedab 26%, #ead290 23%, #b88e4b 19%, #a3732f 17%);
  
//   color: white;

//   &:focus {
//     box-shadow: 0 0 0 1pt ${({ theme }) => darken(0.05, theme.primary1)};
//     background-color: ${({ theme }) => darken(0.05, theme.primary1)};
//   }
//   &:hover {
//     background-color: ${({ theme }) => darken(0.05, theme.primary1)};
//   }
//   &:active {
//     box-shadow: 0 0 0 1pt ${({ theme }) => darken(0.1, theme.primary1)};
//     background-color: ${({ theme }) => darken(0.1, theme.primary1)};
//   }
//   &:disabled {
//     background-image: none;
//     background-color: ${({ theme, altDisabledStyle, disabled }) =>
//       altDisabledStyle ? (disabled ? theme.bg3 : theme.primary1) : theme.bg3};
//     color: ${({ theme, altDisabledStyle, disabled }) =>
//       altDisabledStyle ? (disabled ? theme.text3 : 'white') : theme.text3};
//     cursor: auto;
//     box-shadow: none;
//     border: 1px solid transparent;
//     border: none;
//     outline: none;
//     opacity: ${({ altDisabledStyle }) => (altDisabledStyle ? '0.5' : '1')};
//   }

//   background: rgb(163,115,47);
//   background: -moz-linear-gradient(283deg, rgba(163,115,47,1) -35%, rgba(184,142,75,1) -28%, rgba(234,210,144,1) -10%, rgba(255,237,171,1) 1%, rgba(242,222,157,1) 6%, rgba(211,184,121,1) 16%, rgba(160,122,63,1) 32%, rgba(130,86,29,1) 40%, rgba(206,162,83,1) 63%, rgba(255,234,165,1) 146%, rgba(54,31,0,1) 179%, rgba(163,115,47,1) 195%, rgba(181,137,71,1) 223%);
//   background: -webkit-linear-gradient(283deg, rgba(163,115,47,1) -35%, rgba(184,142,75,1) -28%, rgba(234,210,144,1) -10%, rgba(255,237,171,1) 1%, rgba(242,222,157,1) 6%, rgba(211,184,121,1) 16%, rgba(160,122,63,1) 32%, rgba(130,86,29,1) 40%, rgba(206,162,83,1) 63%, rgba(255,234,165,1) 146%, rgba(54,31,0,1) 179%, rgba(163,115,47,1) 195%, rgba(181,137,71,1) 223%);
//   background: linear-gradient(283deg, rgba(163,115,47,1) -35%, rgba(184,142,75,1) -28%, rgba(234,210,144,1) -10%, rgba(255,237,171,1) 1%, rgba(242,222,157,1) 6%, rgba(211,184,121,1) 16%, rgba(160,122,63,1) 32%, rgba(130,86,29,1) 40%, rgba(206,162,83,1) 63%, rgba(255,234,165,1) 146%, rgba(54,31,0,1) 179%, rgba(163,115,47,1) 195%, rgba(181,137,71,1) 223%);
//   filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#a3732f",endColorstr="#b58947",GradientType=1);
// `

export const ButtonConnectMetamask = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;

  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  transition-property: all;
  transition-duration: 0.2s;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

  span {
    padding: 18px;
    cursor: pointer;
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    border-radius: 5px;
    --tw-bg-opacity: 1;
    background-image: linear-gradient(98deg, #e45e37 0%, #d44f29 96%);
    padding-left: 2rem;
    padding-right: 2rem;
    font-size: 15px;
    transition-property: all;
    transition-duration: 0.2s;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);

    & > img {
      width: auto;
      height: 1.25rem;
      margin: 1.5px 0 1.3px 0;
      object-fit: contain;
    }
  }

  &:hover {
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
    --tw-shadow: 0px 4px 30px 0px #e45e37;
    --tw-shadow-colored: 0px 4px 30px 0px var(--tw-shadow-color);
    span {
      --tw-text-opacity: 1;
      color: rgb(255 255 255 / var(--tw-text-opacity));
    }
  }
`

export const ButtonLight = styled(Base)`
  background-image: linear-gradient(80deg, #1fc7ae 13%, #7c73b4 86%);
  background-color: ${({ theme }) => theme.primary5};
  color: ${({ theme }) => theme.primaryText1};
  color: white;
  font-size: 16px;
  font-weight: 500;
  &:focus {
    box-shadow: 0 0 0 1pt ${({ theme, disabled }) => !disabled && darken(0.03, theme.primary5)};
    background-color: ${({ theme, disabled }) => !disabled && darken(0.03, theme.primary5)};
  }
  &:hover {
    background-color: ${({ theme, disabled }) => !disabled && darken(0.03, theme.primary5)};
  }
  &:active {
    box-shadow: 0 0 0 1pt ${({ theme, disabled }) => !disabled && darken(0.05, theme.primary5)};
    background-color: ${({ theme, disabled }) => !disabled && darken(0.05, theme.primary5)};
  }
  :disabled {
    opacity: 0.4;
    :hover {
      cursor: auto;
      background-color: ${({ theme }) => theme.primary5};
      box-shadow: none;
      border: 1px solid transparent;
      outline: none;
    }
  }
`

export const ButtonGray = styled(Base)`
  background-color: ${({ theme }) => theme.bg3};
  color: ${({ theme }) => theme.text2};
  font-size: 16px;
  font-weight: 500;
  &:focus {
    background-color: ${({ theme, disabled }) => !disabled && darken(0.05, theme.bg4)};
  }
  &:hover {
    background-color: ${({ theme, disabled }) => !disabled && darken(0.05, theme.bg4)};
  }
  &:active {
    background-color: ${({ theme, disabled }) => !disabled && darken(0.1, theme.bg4)};
  }
`

export const ButtonSecondary = styled(Base)`
  border: 1px solid #224765;
  color: #fff;
  background: linear-gradient(to bottom, #11314a, #0c2539);
  font-size: 16px;
  border-radius: 5px;
  padding: ${({ padding }) => (padding ? padding : '10px')};

  &:focus {
    box-shadow: 0 0 0 1pt ${({ theme }) => theme.primary4};
    //border: 1px solid ${({ theme }) => theme.primary3};
  }
  &:hover {
    box-shadow: 0px 4px 30px 0px rgba(110, 177, 242, .4);
    //border: 1px solid ${({ theme }) => theme.primary3};
  }
  &:active {
    box-shadow: 0 0 0 1pt ${({ theme }) => theme.primary4};
    border: 1px solid ${({ theme }) => theme.primary3};
  }
  &:disabled {
    opacity: 50%;
    cursor: auto;
  }
  a:hover {
    text-decoration: none;
  }
`

export const ButtonPink = styled(Base)`
  background-color: ${({ theme }) => theme.primary1};
  color: white;

  &:focus {
    box-shadow: 0 0 0 1pt ${({ theme }) => darken(0.05, theme.primary1)};
    background-color: ${({ theme }) => darken(0.05, theme.primary1)};
  }
  &:hover {
    background-color: ${({ theme }) => darken(0.05, theme.primary1)};
  }
  &:active {
    box-shadow: 0 0 0 1pt ${({ theme }) => darken(0.1, theme.primary1)};
    background-color: ${({ theme }) => darken(0.1, theme.primary1)};
  }
  &:disabled {
    background-color: ${({ theme }) => theme.primary1};
    opacity: 50%;
    cursor: auto;
  }
`

export const ButtonUNIGradient = styled(ButtonPrimary)`
  color: white;
  padding: 4px 8px;
  height: 36px;
  font-weight: 500;
  background-color: ${({ theme }) => theme.bg3};
  background: radial-gradient(174.47% 188.91% at 1.84% 0%, #ff007a 0%, #2172e5 100%), #edeef2;
  width: fit-content;
  position: relative;
  cursor: pointer;
  border: none;
  white-space: no-wrap;
  :hover {
    opacity: 0.8;
  }
  :active {
    opacity: 0.9;
  }
`

export const ButtonOutlined = styled(Base)`
  border: 1px solid ${({ theme }) => theme.bg2};
  background-color: transparent;
  color: ${({ theme }) => theme.text1};

  &:focus {
    box-shadow: 0 0 0 1px ${({ theme }) => theme.bg4};
  }
  &:hover {
    box-shadow: 0 0 0 1px ${({ theme }) => theme.bg4};
  }
  &:active {
    box-shadow: 0 0 0 1px ${({ theme }) => theme.bg4};
  }
  &:disabled {
    opacity: 50%;
    cursor: auto;
  }
`

export const ButtonEmpty = styled(Base)`
  background-color: transparent;
  color: ${({ theme }) => theme.primary1};
  display: flex;
  justify-content: center;
  align-items: center;

  &:focus {
    text-decoration: underline;
  }
  &:hover {
    text-decoration: none;
  }
  &:active {
    text-decoration: none;
  }
  &:disabled {
    opacity: 50%;
    cursor: auto;
  }
`

export const ButtonWhite = styled(Base)`
  border: 1px solid #edeef2;
  background-color: ${({ theme }) => theme.bg1};
  color: black;

  &:focus {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    box-shadow: 0 0 0 1pt ${darken(0.05, '#edeef2')};
  }
  &:hover {
    box-shadow: 0 0 0 1pt ${darken(0.1, '#edeef2')};
  }
  &:active {
    box-shadow: 0 0 0 1pt ${darken(0.1, '#edeef2')};
  }
  &:disabled {
    opacity: 50%;
    cursor: auto;
  }
`

const ButtonConfirmedStyle = styled(Base)`
  background-color: ${({ theme }) => lighten(0.5, theme.green1)};
  color: ${({ theme }) => theme.green1};
  border: 1px solid ${({ theme }) => theme.green1};

  &:disabled {
    opacity: 50%;
    cursor: auto;
  }
`

const ButtonErrorStyle = styled(Base)`
  background-color: ${({ theme }) => theme.red1};
  border: 1px solid ${({ theme }) => theme.red1};

  &:focus {
    box-shadow: 0 0 0 1pt ${({ theme }) => darken(0.05, theme.red1)};
    background-color: ${({ theme }) => darken(0.05, theme.red1)};
  }
  &:hover {
    background-color: ${({ theme }) => darken(0.05, theme.red1)};
  }
  &:active {
    box-shadow: 0 0 0 1pt ${({ theme }) => darken(0.1, theme.red1)};
    background-color: ${({ theme }) => darken(0.1, theme.red1)};
  }
  &:disabled {
    opacity: 50%;
    cursor: auto;
    box-shadow: none;
    background-color: ${({ theme }) => theme.red1};
    border: 1px solid ${({ theme }) => theme.red1};
  }
`

export function ButtonConfirmed({
  confirmed,
  altDisabledStyle,
  ...rest
}: { confirmed?: boolean; altDisabledStyle?: boolean } & ButtonProps) {
  if (confirmed) {
    return <ButtonConfirmedStyle {...rest} />
  } else {
    return <ButtonPrimary {...rest} altDisabledStyle={altDisabledStyle} />
  }
}

export function ButtonError({ error, ...rest }: { error?: boolean } & ButtonProps) {
  if (error) {
    return <ButtonErrorStyle {...rest} />
  } else {
    return <ButtonPrimary {...rest} />
  }
}

export function ButtonDropdown({ disabled = false, children, ...rest }: { disabled?: boolean } & ButtonProps) {
  return (
    <ButtonPrimary {...rest} disabled={disabled}>
      <RowBetween>
        <div style={{ display: 'flex', alignItems: 'center' }}>{children}</div>
        <ChevronDown size={24} />
      </RowBetween>
    </ButtonPrimary>
  )
}

export function ButtonDropdownGrey({ disabled = false, children, ...rest }: { disabled?: boolean } & ButtonProps) {
  return (
    <ButtonGray {...rest} disabled={disabled} style={{ borderRadius: '20px' }}>
      <RowBetween>
        <div style={{ display: 'flex', alignItems: 'center' }}>{children}</div>
        <ChevronDown size={24} />
      </RowBetween>
    </ButtonGray>
  )
}

export function ButtonDropdownLight({ disabled = false, children, ...rest }: { disabled?: boolean } & ButtonProps) {
  return (
    <ButtonOutlined {...rest} disabled={disabled}>
      <RowBetween>
        <div style={{ display: 'flex', alignItems: 'center' }}>{children}</div>
        <ChevronDown size={24} />
      </RowBetween>
    </ButtonOutlined>
  )
}

export function ButtonRadio({ active, ...rest }: { active?: boolean } & ButtonProps) {
  if (!active) {
    return <ButtonWhite {...rest} />
  } else {
    return <ButtonPrimary {...rest} />
  }
}
